import type { Props } from 'src/components/ui/Icon'
import Icon from 'src/components/ui/Icon'

export const ButtonIcon = (props: Props) => {
  return <Icon {...props} />
}
